import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { BankAccountType } from '@square/dashboard-protos/models/squareup/bank-accounts/bank_accounts';
import { htmlSafe } from '@ember/template';
export async function getFirstSelectedUnitToken(locationSelector, single = false, tokens) {
  await locationSelector.configure({
    hideInactiveUnits: true,
    single,
    tokens
  });
  const unitToken = locationSelector.firstSelectedUnit?.token;
  if (unitToken == null || typeof unitToken === 'undefined') {
    throw new TypeError('unitToken must be defined');
  }
  return unitToken;
}
export async function getAllUnitTokens(locationSelector) {
  await locationSelector.configure({
    hideInactiveUnits: true
  });
  return locationSelector.units.map(unit => unit.token);
}
export function formatNumber(number = '', indices) {
  const numberSplit = [...number];
  for (const i of indices) {
    numberSplit.splice(i, 0, ' ');
  }
  return numberSplit.join('');
}
export function getAccountType(accountType, countryCode, intl) {
  switch (accountType) {
    case AccountType.CHECKING_ACCOUNT:
      return countryCode === Country.US ? intl.t('banking.checking.accountType.checking') : intl.t('banking.checking.accountType.squareCard');
    case AccountType.CLEARING_ACCOUNT:
      return intl.t('banking.checking.accountType.automatic');
    case AccountType.MANUAL_SETTLEMENT_CHECKING_ACCOUNT:
      return intl.t('banking.checking.accountType.manual');
    default:
      return intl.t('banking.checking.accountType.default');
  }
}
export function getBankAccountType(bankAccountType, intl) {
  switch (bankAccountType) {
    case BankAccountType.CHECKING:
      return intl.t('banking.unifiedBankAccounts.bankAccountType.checking');
    case BankAccountType.SAVINGS:
      return intl.t('banking.unifiedBankAccounts.bankAccountType.savings');
    case BankAccountType.INVESTMENT:
      return intl.t('banking.unifiedBankAccounts.bankAccountType.investment');
    case BankAccountType.BUSINESS_CHECKING:
      return intl.t('banking.unifiedBankAccounts.bankAccountType.businessChecking');
    default:
      return intl.t('banking.unifiedBankAccounts.bankAccountType.other');
  }
}
export function getLinkedBankAccountLabel(linkedBankAccount, intl) {
  const {
    bankName,
    accountNumberSuffix,
    type
  } = linkedBankAccount;
  const bankType = getBankAccountType(type, intl);
  return {
    bankAccountLabelHtmlSafe: htmlSafe(intl.t('banking.unifiedBankAccounts.allLocations.locationRow.linkedBankAccountHtmlSafe', {
      bankName,
      bankType,
      accountNumberSuffix
    })),
    bankAccountLabel: intl.t('banking.unifiedBankAccounts.allLocations.locationRow.linkedBankAccount', {
      bankName,
      bankType,
      accountNumberSuffix
    })
  };
}